import { makeAttachedBlock } from "../attachedBlock";

const block = makeAttachedBlock(
  "attached-skills",
  "The user explicitly activated these skills for this message:"
);

export const buildAttachedSkillsBlock = block.build;
export const prependAttachedSkills = block.prepend;
export const attachedSkillNames = block.names;
export const stripAttachedSkillsBlock = block.strip;
